import React, { useState } from "react";
import { Icon } from "@iconify/react";
import { Link, useNavigate } from "react-router-dom";
import { Form } from "react-bootstrap";
import authSvc from "../../services/auth-service";
import { useDispatch } from "react-redux";
import { login, setUser } from "../../redux/authSlice";

const LoginForm = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const loginUser = async (e) => {
    e.preventDefault();
    const { isLoggedIn, user } = await authSvc.login(email, password);
    if (isLoggedIn) {
      dispatch(login());
      dispatch(setUser(user));
      navigate("/");
    }
  };
  return (
    <form className="customForm" onSubmit={(e) => loginUser(e)}>
      <div className="title">
        <h2>Let’s sign you in.</h2>
        <p>
          Welcome back <br /> to your workspace!
        </p>
      </div>
      <div className="fieldset mb-4">
        <Form.Group>
          <Form.Label>Email address</Form.Label>
          <Form.Control
            type="email"
            required
            placeholder="name@example.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </Form.Group>
      </div>
      <div className="fieldset mb-3">
        <i onClick={() => setShowPassword(!showPassword)}>
          {!showPassword ? (
            <Icon icon="clarity:eye-line" />
          ) : (
            <Icon icon="clarity:eye-hide-line" />
          )}
        </i>
        <Form.Group>
          <Form.Label>Password</Form.Label>
          <Form.Control
            type={showPassword ? "text" : "password"}
            placeholder="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </Form.Group>
      </div>
      <div className="cta-forget">
        <Link to="/forget-password">Forgot your password?</Link>
      </div>
      <button className="w-100 btn cta-primary">Sign In</button>
    </form>
  );
};

export default LoginForm;
